import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { CalendarBox } from './CalendarBox';
import { TranslationUtils } from '../../utils';
import _ from 'lodash';
import { CalendarAvailability } from './Calendar';

interface CalendarSelectionBoxProps {
    dates: CalendarAvailability;
    setDate: (date: moment.Moment) => void;
    type: 'check_in' | 'check_out';
    date: string;
    clean: boolean;
    isLoading: boolean;
}

const defaultMap = new Map<string, boolean>();

export const CalendarSection: React.FC<CalendarSelectionBoxProps> = (props) => {
    const { type, date: baseDate, dates } = props;
    const disable = dates.filter((v) => _.isNil(v?.bookable) || v?.bookable !== false).length === 0;
    const [selectedObj, setSelectedObj] = useState<Map<string, boolean>>(defaultMap);

    useEffect(() => {
        setSelectedObj(defaultMap);
    }, [props.clean]);

    const emptyErrorText =
        type === 'check_in' ? TranslationUtils.get('empty_calendar_before_options') : TranslationUtils.get('empty_calendar_after_options');

    const setSelected = (selectedDate: string) => {
        const curr = moment(selectedDate);
        const map = new Map<string, boolean>();

        for (const pivot of dates) {
            // check-in
            if (curr.isBefore(baseDate)) {
                // we select from the curr to the last position of the arr (check-in)
                map.set(pivot.date, curr.isSameOrBefore(pivot.date));
            }
            // check-out
            if (curr.isAfter(baseDate)) {
                // we select from the first potion of arr (check-out) until the curr
                map.set(pivot.date, curr.isSameOrAfter(pivot.date));
            }
        }

        setSelectedObj(map);
    };

    return (
        <div id={'check-box'} className={'d-flex flex-column'}>
            <div id={'section-date-description'} className={'d-flex flex-column'}>
                <span id={'section-subtitle'} className={'font-subtitle-calendar'}>
                    {TranslationUtils.get(type)}
                </span>
                <span id={'section-dates-header'} className={'font-dates-header-calendar pb-16'}>
                    {moment(baseDate).format('ddd, MMM DD, YYYY')}
                </span>
                <span id={'section-calendar-description'} className={'font-description-calendar pb-8'}>
                    {TranslationUtils.get(`${type}_description`)}
                </span>
            </div>
            <div id={'section-date-options'} className={'d-flex gap-16'}>
                {dates.map((value, _index) => (
                    <CalendarBox
                        key={value.date}
                        date={value.date}
                        base={value.date === baseDate}
                        isLoading={props.isLoading}
                        selected={selectedObj.get(value.date) ?? false}
                        bookable={value.bookable}
                        setSelected={(value: string) => setSelected(value)}
                        setDate={(date: moment.Moment) => props.setDate(date)}
                    />
                ))}
            </div>
            {disable && (
                <span id={'section-error'} className={'font-dates-calendar text-danger pt-8'}>
                    {emptyErrorText}
                </span>
            )}
        </div>
    );
};
